import React from 'react';
import PropTypes from 'prop-types';
import tokenReplace from 'dibs-token-replace';
import SanitizeHtml from '../../../global/components/SanitizeHtml';

function SimilarHeaderSold({ copy, title }) {
    const soldCopy = copy.soldHeader;
    const allowedTags = ['i'];
    const soldHeader = tokenReplace(soldCopy, {
        itemTitle: title,
    });

    return (
        <h2 className="pdp-similar-header-module">
            <SanitizeHtml allowedTags={allowedTags} content={soldHeader} />
        </h2>
    );
}

SimilarHeaderSold.propTypes = {
    copy: PropTypes.object,
    title: PropTypes.string,
};

module.exports = SimilarHeaderSold;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Similar/SimilarHeaderSold.jsx